export default __webpack_public_path__ + "static/media/mercadoPagoFormasPagamento.e33a4e46.webp";